export default "__VITE_ASSET__DcoaxALY__"